<div class="status" data-cy="status-container">
  <span
    *ngIf="
      !!status &&
      isCard &&
      !isResubmitting &&
      (serviceRequestType !== requestRef.SUPPORT_REQUEST ||
        statusRef.NEW !== status)
    "
    class="circle"
    data-cy="target-circle"
    [class.fail]="statusRef.FAILED === status"
    [class.orange]="
      statusRef.NEW === status ||
      statusRef.CREATED === status ||
      statusRef.PENDING_CDMR_DECISION === status ||
      statusRef.IN_PROGRESS === status
    "
    [class.approve]="statusRef.APPROVED === status"
    [class.close]="statusRef.CLOSED === status"
  ></span>
  <p
    *ngIf="!!status && !isResubmitting"
    data-cy="target-label"
    [class.bold]="
      serviceRequestType !== requestRef.SUPPORT_REQUEST ||
      statusRef.NEW !== status
    "
    [class.fail]="statusRef.FAILED === status"
    [class.orange]="
      (statusRef.NEW === status &&
        serviceRequestType !== requestRef.SUPPORT_REQUEST) ||
      statusRef.CREATED === status ||
      statusRef.PENDING_CDMR_DECISION === status ||
      statusRef.IN_PROGRESS === status
    "
    [class.approve]="statusRef.APPROVED === status"
    [class.close]="statusRef.CLOSED === status"
    [class.mobile]="platformRef.mobile === platform"
    [class.modal]="!isCard"
  >
    {{ statusText | translate }}
  </p>

  <span
    *ngIf="!!isResubmitting && isCard"
    class="circle resubmit"
    data-cy="target-circle"
  ></span>
  <p
    *ngIf="!!isResubmitting"
    data-cy="target-label"
    class="resubmit"
    [class.modal]="!isCard"
  >
    {{ 'i18n.supportCenter.status.resubmit' | translate }}
  </p>
</div>
